export function isInternetExplorer() {
  var isoldIE = navigator.appName == "Microsoft Internet Explorer";
  return (
    isoldIE ||
    (navigator.appName == "Netscape" &&
      new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent) != null)
  );
}
